import currency from 'currency.js';
import { find } from 'lodash';

import DayJs from 'utils/Dayjs';
import { USER_ROLES, TASK_TYPES } from 'utils/Constants';

// Returns user's role name from number
export const getRole = role => {
	return find(USER_ROLES, ['value', role]).text;
};

// Returns task's type name from number
export const getTaskType = type => {
	return find(TASK_TYPES, ['value', type]).text;
};

export const safeStringify = value => {
	try {
		return typeof value === 'object' ? JSON.stringify(value) : value;
	} catch {
		return '';
	}
};

export const safeParse = value => {
	try {
		return typeof value === 'string' ? JSON.parse(value) : value;
	} catch {
		return '';
	}
};

// Convert parts to minutes
export const partsToMinutes = ({ days = 0, hours = 0, minutes = 0 }) => {
	return (days * 24 * 60) + (hours * 60) + (+minutes);
};

// Convert minutes to parts
export const minutesToParts = (m) => {
	return {
		days: Math.floor(m / 1440),
		hours: Math.floor(m % 1440 / 60),
		minutes: Math.floor(m % 60)
	};
};

// Convert seconds to parts
export const secondsToParts = (s) => {
	const hours = Math.floor(s % 86400 / 3600);
	const minutes = Math.floor(s % 3600 / 60);
	const seconds = Math.floor(s % 60);

	return {
		days: Math.floor(s / 86400),
		hours: (hours.toString().length < 2 && hours !== 0)  ? `0${hours}` : hours,
		minutes: minutes.toString().length < 2 ? `0${minutes}` : minutes,
		seconds: seconds.toString().length < 2 ? `0${seconds}` : seconds
	};
};

// Convert int price to readable price
export const priceToReadable = (price) => {
	return `${Number(currency(price, { precision: 2, fromCents: true }).value).toFixed(2)} €`;
};

// Find closest first september
export const getClosestFirstSeptember = (offset) => {
	const today = DayJs();
	const closest = today.month(8).date(1).add(offset, 'year');
	// if (closest.isBefore(today)) return closest.add(1, 'year').toISOString();
	return closest.startOf('day').toISOString();
};


// Find closest last may
export const getClosestLastMay = (start) => {
	const september = DayJs(start);
	const closest = september.add(1, 'year').month(4).date(31);
	// if (closest.isBefore(today)) return closest.add(1, 'year').toISOString();
	return closest.endOf('day').toISOString();
};
